(function($) {

  'use strict';

  function FileUpload() {

    var self = this,
      $el = null,
      $wrapper = null,
      $fileInput = null,
      $clearButton = null,
      $addButton = null,
      labelFileInput = null,
      labelEmptyFileInput = null,

      options = {
        'example': null
      };

    function hideFilename(forceEmpty) {
      $wrapper.addClass('is-blank');
      $wrapper.find(labelFileInput).html('');
      $wrapper.find(labelEmptyFileInput).removeClass('js-hide');

      $clearButton.hide();
      $addButton.show();

      // Manually empty field
      if (forceEmpty) {
        $fileInput.val('').trigger('change');
      }
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      //extends options
      for (var i in opts) { options[i] = opts[i]; }

      // console.log('Fileupload');

      // Caching
      $wrapper = options.$el;
      $fileInput = $wrapper.find('.js-fileupload-input');
      $clearButton = $wrapper.find('.js-fileupload-clear');
      $addButton = $wrapper.find('.js-fileupload-add');
      labelFileInput = '.js-fileupload-txt';
      labelEmptyFileInput = '.js-fileupload-txt-nofile';

      // Setup
      $wrapper.addClass('is-blank');

      /**
       * Input File
       */
      // File uploaded
      $fileInput.change(function() {
        var fileName = $(this).val().split(/\\/).pop();

        // File selected
        $wrapper.removeClass('is-blank');
        $wrapper.find(labelEmptyFileInput).addClass('js-hide');
        $wrapper.find(labelFileInput).html(fileName);
        $clearButton.show();
        $addButton.hide();

        // If Cancel
        if ($(this).val() === '') {
          hideFilename(false);
        }
      });

      $clearButton.on('click', function() {
        hideFilename(true);
      });

    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.FileUpload = FileUpload;

}(jQuery));
